<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">Goals</span>
    </div>
    <div class="flex gap-2 items-center">
      <label nz-checkbox [(ngModel)]="includeTestUsers" (ngModelChange)="applyFilters()">
        Include test users
      </label>
      <nz-range-picker
        [ngModel]="[startDateFrom, startDateTo]"
        (ngModelChange)="onDateRangeChange($event); applyFilters()"
        nzPlaceHolder="['Started from', 'Started to']"
      ></nz-range-picker>
      <button nz-button nzSize="small" nzType="primary" (click)="clearFilters()">
        Clear filters
      </button>
    </div>
  </div>
</ng-template>

<nz-card [nzTitle]="tableHead" [nzLoading]="pageLoading">
  <nz-table
    #goalsTable
    [nzData]="data"
    [nzLoading]="tableLoading"
    [nzFrontPagination]="false"
    [nzTotal]="totalRecords"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzPageSizeOptions]="pageSizeOptions"
    (nzPageIndexChange)="nzPageIndexChange($event)"
    (nzPageSizeChange)="nzPageSizeChange($event)"
  >
    <thead>
      <tr>
        <th>
          User
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="userMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Partner
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="partnerMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Hero Pillar
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="pillarMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Source
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="sourceMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Status
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="statusMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Archived
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="archivedMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Assigned Expert
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="expertMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>Objectives</th>
        <th>Started</th>
        <th>Last Updated</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data">
        <td>
          <div>{{ row.userName || '(unknown)' }}</div>
          <div class="text-xs text-gray-500">{{ row.userEmail || '-' }}</div>
        </td>
        <td>{{ row.partnerId || '-' }}</td>
        <td>{{ row.heroPillar || '-' }}</td>
        <td>{{ row.source }}</td>
        <td>
          <nz-tag [nzColor]="row.status === GoalStatus.ACTIVE ? 'green' : row.status === GoalStatus.PAUSED ? 'orange' : 'red'">
            {{ row.status }}
          </nz-tag>
        </td>
        <td>{{ row.isArchived ? 'Archived' : 'Active' }}</td>
        <td>{{ row.assignedExpertName || '-' }}</td>
        <td>{{ row.objectiveCount }}</td>
        <td>{{ row.startDate | date: 'medium' }}</td>
        <td>{{ row.lastModifiedAt | date: 'medium' }}</td>
        <td>
          <div class="flex gap-1 flex-wrap">
            <button
              nz-button
              nzSize="small"
              [disabled]="!canPause(row) || actionLoading"
              (click)="pauseGoal(row)"
            >
              Pause
            </button>
            <button
              nz-button
              nzSize="small"
              [disabled]="!canResume(row) || actionLoading"
              (click)="resumeGoal(row)"
            >
              Resume
            </button>
            <button
              nz-button
              nzSize="small"
              nzDanger
              [disabled]="!canAbandon(row) || actionLoading"
              (click)="openAbandonModal(row)"
            >
              Abandon
            </button>
            <button
              nz-button
              nzSize="small"
              nzType="dashed"
              [disabled]="!canForceRecalc(row) || actionLoading"
              (click)="forceRecalc(row)"
            >
              Force Recalc
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-card>

<nz-dropdown-menu #userMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="userSearch"
          nz-input
          placeholder="Search by name or email"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #partnerMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="partnerIdSearch"
          nz-input
          placeholder="Search by partner"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #pillarMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onHeroPillarFilterChange($event)">
      <div *ngFor="let pillar of pillarOptions" nz-row class="m-1">
        <label nz-checkbox [nzValue]="pillar" [ngModel]="heroPillarFilterValues.includes(pillar)">
          {{ pillar }}
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #sourceMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onSourceFilterChange($event)">
      <div *ngFor="let source of sourceOptions" nz-row class="m-1">
        <label nz-checkbox [nzValue]="source" [ngModel]="sourceFilterValues.includes(source)">
          {{ source }}
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #statusMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onStatusFilterChange($event)">
      <div *ngFor="let status of statusOptions" nz-row class="m-1">
        <label nz-checkbox [nzValue]="status" [ngModel]="statusFilterValues.includes(status)">
          {{ status }}
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #archivedMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onIsArchivedFilterChange($event)">
      <div nz-row class="m-1">
        <label nz-checkbox nzValue="false" [ngModel]="isArchivedFilterValues.includes('false')">
          Active
        </label>
      </div>
      <div nz-row class="m-1">
        <label nz-checkbox nzValue="true" [ngModel]="isArchivedFilterValues.includes('true')">
          Archived
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #expertMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="assignedExpertNameSearch"
          nz-input
          placeholder="Search by expert name"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-modal
  [(nzVisible)]="isAbandonModalOpen"
  nzTitle="Abandon this goal?"
  (nzOnCancel)="isAbandonModalOpen = false"
  (nzOnOk)="confirmAbandon()"
  [nzOkLoading]="actionLoading"
  nzOkText="Abandon"
  nzOkDanger="true"
>
  <ng-container *nzModalContent>
    <p>
      This will permanently abandon
      {{ abandonTargetRow?.userName || abandonTargetRow?.userEmail || 'this user' }}'s
      current goal.
    </p>
    <textarea
      nz-input
      [(ngModel)]="abandonReason"
      placeholder="Reason (optional)"
      rows="3"
    ></textarea>
  </ng-container>
</nz-modal>
